export default "__VITE_ASSET__f7f3b46c__"